import { useState } from "react";
import { ExecutionsInsertComponent } from "../AssistanceExecutions/ExecutionsInsertComponent";
import { ExecutionsTableComponent } from "../AssistanceExecutions/ExecutionsTableComponent";

type AssistanceExecutionsComponentType = {
    assistanceId: number;
    reloadExecutions: boolean;
    mode: "workshop" | "backoffice";
    isComplete: boolean;
    onFetchExecutionsData: () => void;
    equipmentId?: number;
}

export function AssistanceExecutionsComponent({ assistanceId, reloadExecutions, mode, isComplete, equipmentId, ...props }: AssistanceExecutionsComponentType) {
    const [reloadExecutionsTable, setReloadExecutionsTable] = useState<boolean>(false);
    const reloadExecutionsTableFunction = () => {
        setReloadExecutionsTable(!reloadExecutionsTable);
    }

    return (
        <>
            <ExecutionsInsertComponent
                assistanceId={assistanceId}
                reloadExecutionsTable={reloadExecutionsTableFunction}
                isComplete={isComplete}
                onFetchExecutionsData={props.onFetchExecutionsData}
                equipmentId={equipmentId}
            />

            {/* Tabela das execuções */}
            <ExecutionsTableComponent
                assistanceId={assistanceId}
                reloadExecutions={reloadExecutions || reloadExecutionsTable}
                mode={mode}
                isComplete={isComplete}
                onFetchExecutionsData={props.onFetchExecutionsData}
            />
        </>
    );
}